






















import Vue from 'vue';
import NOC from '@/class/common/const';

export default Vue.extend({
  name: 'Forget',
  data() {
    return {
      mail: '',
      error: '',
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  methods: {
    async onClickForget() {
      this.error = '';
      if (this.mail.length === 0) {
        this.error = '必須項目です。';
        return;
      } else if (!this.validEmail(this.mail)) {
        this.error = '半角英数字@半角英数字形式にしてください。';
        return;
      }  else if (this.mail.length > 40) {
        this.error = '最大桁数は40文字です。';
        return;
      }
      this.$emit('forget', this.mail);
    },
    validEmail: (mail: string) => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(mail);
    },
  },
});
